export default "__VITE_ASSET__WP5y6RNz__"